// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

const relatedPropertiesSwiperArray = document.querySelectorAll('.swiper--related-properties__homepage--land')

if (relatedPropertiesSwiperArray) {

  relatedPropertiesSwiperArray.forEach((relatedPropertiesSwiper) => {
    // count number of slides to fix loop bug
    var slidesCount = relatedPropertiesSwiper.getElementsByClassName('swiper-slide').length;

    var config = {
      // Optional parameters
      direction: 'vertical',
      slidesPerView: 1,
      spaceBetween: 15,
      watchOverflow: true,
      loop: false,
      breakpoints : {
        768 : {
          direction: 'horizontal',
          slidesPerView: 2,
          loop: slidesCount > 2,
        },
        1024 : {
          slidesPerView: 3,
          loop: slidesCount > 3,
        },
        1280 : {
          slidesPerView: 4,
          loop: slidesCount > 4,
        }
      },
    }

    // init Swiper:

    let swiper = new Swiper('.swiper--related-properties__homepage--land', config);

    function swiperChangeDirection(x) {
      if (mdscreen.matches) { // If media query matches
        swiper.destroy();
      } else {
        swiper = new Swiper('.swiper--related-properties__homepage--land', config);
       // swiper.changeDirection('horizontal');
      }
    }

    //window.addEventListener('resize', swiperChangeDirection);

    //var mdscreen = window.matchMedia("(max-width: 1024px)")
    //swiperChangeDirection(mdscreen) // Call listener function at run time
    //mdscreen.addListener(swiperChangeDirection) // Attach listener function on state changes
  })
}

